module.exports = __webpack_public_path__ + "static/media/check-ins-missed.96f95ea0.svg";